const initialState = {
    eventList: [],
    eventLoading: false,
    IsNetworkError: false,
    open: false,
}

const eventReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_EVENT_LIST': {
            return {
                ...state,
                eventList: action?.payload?.results,
                eventLoading: false
            };
        }
        case 'GET_EVENT_LOADING': {
            return {
                ...state,
                eventLoading: action?.payload,
            };
        }

        case 'ONLINE': {
            return {
                ...state,
                IsNetworkError: action?.payload,
            };
        }
        case 'OPEN_DRAWER': {
            const payload = action?.payload;
            const hasObject = payload && typeof payload === 'object' && Object.prototype.hasOwnProperty.call(payload, 'object');

            return {
                ...state,
                open: typeof payload === 'object' ? Boolean(payload?.open) : Boolean(payload),
                object: hasObject ? payload.object : state.object,
            };
        }
        default: {
            return {
                ...state,
            };

        }
    }
}

export default eventReducer;
